

  import Vue from 'vue'
  import Component from "vue-class-component";
  import {namespace} from "vuex-class";

  import axios from "axios";
  import YAML from 'yaml'
  import {settings} from "@/plugins/settings";
  import {PermissionHelper} from "@/helpers/PermissionHelper";
  import {EUserPermissions} from "@/model/EUserPermissions";
  import {IAuthUserData} from "@/store/modules/authModule";

  const SwaggerUI = require('swagger-ui');
  require('swagger-ui/dist/swagger-ui.css');

  const authModule = namespace("authModule");

  @Component({
    name: 'ModuloSwaggerView',
  })
  export default class SwaggerModuloView extends Vue {

    @authModule.Getter('userData')
    private authUser!: IAuthUserData;

    private swagger$: any;

    created() {
      if (!this.authUser || !PermissionHelper.hasPermission(this.authUser, EUserPermissions.PERMISSION_DEVELOPER, 0)) {
        this.$router.push('/');
      }
      this.swagger$ = axios({
        url: settings.endpoint + "swagger.yaml"
      });
    }

    mounted() {
      this.swagger$.then((response: any) => {
        SwaggerUI({
          dom_id: "#swagger-ui-container",
          spec: YAML.parse(response.data),
        });
      })
    }
  }
